import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { articleCategories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-circle-fill text-background-50 text-xl"></i>
            </div>
            <span className={`font-heading text-xl font-bold transition-colors ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}>
              果冻传媒
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? scrolled
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-white bg-white/20'
                  : scrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}
            >
              首页
            </Link>
            <div className="relative group/ctg">
              <button className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1 ${
                location.pathname.startsWith('/category')
                  ? scrolled
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-white bg-white/20'
                  : scrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}>
                服务领域
                <i className="ri-arrow-down-s-line text-sm"></i>
              </button>
              <div className="absolute top-full left-0 mt-1 w-48 py-2 bg-background-50 rounded-lg border border-background-200/80 opacity-0 invisible group-hover/ctg:opacity-100 group-hover/ctg:visible transition-all duration-200">
                {articleCategories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="block px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? scrolled
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-white bg-white/20'
                  : scrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:block">
            <Link
              to="/about#contact"
              className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              联系我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center"
            aria-label="菜单"
          >
            <i className={`text-xl ${scrolled ? 'text-foreground-900' : 'text-white'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            <Link to="/" className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">首页</Link>
            <div className="px-4 py-2 text-xs font-medium text-foreground-400 uppercase tracking-wider">服务领域</div>
            {articleCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-4 py-3 rounded-lg text-sm text-foreground-700 hover:bg-background-100 transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">关于我们</Link>
            <div className="pt-2">
              <Link to="/about#contact" className="block w-full text-center px-5 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap">
                联系我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}